<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      ref="grid"
    ></dx-grid>

    <v-dialog v-model="statusDialog" max-width="440" persistent>
      <v-card v-if="selectedRecord">
        <v-card-title
          class="white--text py-y px-4"
          style="background:#4caf50;font-size:17px;font-weight:600;"
        >
          Update Action Status
        </v-card-title>

        <v-card-text class="pt-4 pb-2 px-4">
          <div class="mb-1 subtitle-1 font-weight-bold">
            {{ selectedRecord.name }}
          </div>
          <div class="caption grey--text mb-1">
            Account ID: {{ selectedRecord.accountID }}
          </div>
          <div class="caption grey--text mb-1">
            Ref #: {{ selectedRecord.cardknoxRefNum }}
          </div>
          <div class="mb-1">
            <span class="caption grey--text">ACH Status: </span>
            <span class="caption font-weight-bold">{{
              selectedRecord.achTransactionStatus
            }}</span>
          </div>
          <div class="mb-3">
            <span class="caption grey--text">Amount: </span>
            <span class="caption font-weight-bold">{{
              selectedRecord.amount | currency
            }}</span>
          </div>

          <v-divider class="mb-4"></v-divider>

          <v-alert
            v-if="selectedRecord.achTransactionStatus === 'Pending'"
            type="warning"
            dense
            text
            value="true"
            class="mb-3"
          >
            ACH status is still <strong>Pending</strong>. Status update is not
            allowed until the ACH clears.
          </v-alert>

          <v-select
            v-model="actionStatus"
            :items="actionStatusOptions"
            label="New Status"
            outlined
            dense
            :disabled="selectedRecord.achTransactionStatus === 'Pending'"
            class="mb-3"
          ></v-select>

          <v-textarea
            v-model="actionNote"
            label="Note (optional)"
            outlined
            dense
            rows="2"
            hide-details
            :disabled="selectedRecord.achTransactionStatus === 'Pending'"
          ></v-textarea>
        </v-card-text>

        <v-card-actions class="px-4 pb-4 pt-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="statusDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="success"
            depressed
            :loading="saving"
            :disabled="selectedRecord.achTransactionStatus === 'Pending'"
            @click="saveStatus()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const ACH_STATUS_ICON = {
  Settled: { icon: "mdi-check-circle", color: "#43a047" },
  Returned: { icon: "mdi-bank-transfer-out", color: "#f35123" },
  Rejected: { icon: "mdi-close-circle", color: "#f35123" },
  Chargeback: { icon: "mdi-alert-circle", color: "#e53935" },
  Cancelled: { icon: "mdi-cancel", color: "#aeb8bf" },
  Hold: { icon: "mdi-clock-alert", color: "#fdb400" },
  Pending: { icon: "mdi-clock-outline", color: "#fdb400" },
  PENDING: { icon: "mdi-clock-outline", color: "#fdb400" },
};

export default {
  data: () => ({
    title: "ACH",
    url: "AchReturnedPayments?isOnlyPending=true",
    actions: [],
    statusDialog: false,
    selectedRecord: null,
    actionStatus: "",
    actionNote: "",
    saving: false,
    actionStatusOptions: ["PENDING", "COMPLETED"],
    columns: [
      {
        field: "achTransactionStatusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        label: " ",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
          width: undefined,
        },
        icon: (value) =>
          (ACH_STATUS_ICON[value] || {}).icon || "mdi-circle-outline",
        iconColor: (value) => (ACH_STATUS_ICON[value] || {}).color || "#aeb8bf",
      },
      {
        field: "achTransactionStatus",
        label: "ACH Status",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "apiEnteredDate",
        label: "Payment Date",
        type: "date",
        format: "MM/dd/yyyy",
        visible: true,
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "name",
        label: "Name",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "accountID",
        label: "Account ID",
        link: "Account View",
        template: "link-cell-template",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "apiStatusCode",
        label: "Status Code",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      //   {
      //     field: "apiResponseResult",
      //     label: "Response",
      //     format: "",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      //   },
      {
        field: "apiResponseError",
        label: "Error Detail",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "userActionStatus",
        label: "Action Status",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "cardknoxRefNum",
        label: "Cardknox Ref #",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "amount",
        label: "Amount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        precision: 3,
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "paymentID",
        label: "Payment ID",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "paymentStatus",
        label: "Payment Status",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "transactionResult",
        label: "Transaction Result",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "userName",
        label: "User",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "cardNumLast5",
        label: "Card Last 5",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "cardType",
        label: "Card Type",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "source",
        label: "Source",
        format: "",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "categories",
        label: "Categories",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "userActionNote",
        label: "Note",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "userActionBy",
        label: "Updated By",
        format: "",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "userActionAt",
        label: "Updated At",
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "createdAt",
        label: "Log Created",
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  async created() {
    const routeRecordId =
      this.$route && this.$route.query ? this.$route.query.id : null;

    this.actions.push({
      text: "Action Required",
      type: "switch",
      align: "left",
      value: true,
      action: this.onPendingActionChanged,
    });

    if (routeRecordId) {
      await this.openRouteRecord(routeRecordId);
    }
  },
  methods: {
    async openRouteRecord(id) {
      const escapedCardknoxRefNum = String(id).replace(/'/g, "''");
      const response = await this.$http.get(
        `/odata/AchReturnedPayments?isOnlyPending=false&$filter=cardknoxRefNum eq '${escapedCardknoxRefNum}'`
      );

      if (!response || !response.value || !response.value[0]) {
        return;
      }

      this.onRowClicked(response.value[0]);
    },
    onPendingActionChanged(value) {
      this.url = `AchReturnedPayments?isOnlyPending=${value}`;
      this.$refs.grid.reloadDataSource(this.url);
    },
    onRowClicked(row) {
      this.selectedRecord = row;
      this.actionStatus = row.userActionStatus || "PENDING";
      this.actionNote = row.userActionNote || "";
      this.statusDialog = true;
    },
    async saveStatus() {
      this.saving = true;
      try {
        await this.$http.post("api/AchReturnedPayments/UpdateUserAction", {
          aCHApiReportLogID: this.selectedRecord.achApiReportLogID,
          userActionStatus: this.actionStatus,
          userActionNote: this.actionNote || null,
        });
        this.statusDialog = false;
        this.saving = false;
        this.$refs.grid.reloadGrid();
        this.$notify({
          text: "Status updated",
          group: "notification",
          type: "success",
        });
      } catch (e) {
        this.saving = false;
      }
    },
  },
};
</script>
